import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import FlashAlert from "../../Components/FlashAlert/FlashAlert";
import apiService from "../../services/api.service";

const DashboardStartEvents = () => {
  const [eventId, setEventId] = useState("");
  const [eventToStart, setEventToStart] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [lookingUp, setLookingUp] = useState(false);
  const [starting, setStarting] = useState(false);

  const closeConfirm = () => {
    if (starting) return;
    setEventToStart(null);
  };

  const handleLookup = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    const id = Number(eventId);
    if (!id) {
      setError("Inserisci un ID evento valido.");
      return;
    }
    setLookingUp(true);
    try {
      const response = await apiService.getEvents();
      const event = (response.data || []).find((item) => Number(item.id) === id);
      if (!event) {
        setError("Evento non trovato.");
        return;
      }
      if (event.finished) {
        setError("Questo evento è già terminato.");
        return;
      }
      if (!event.embed_link) {
        setError("Aggiungi il link della diretta all'evento prima di avviarlo.");
        return;
      }
      const statusResponse = await apiService.getEventStatus(id);
      const status = statusResponse.data?.status || statusResponse.data;
      if (status === "active") {
        setError("Questo evento è già avviato.");
        return;
      }
      setEventToStart(event);
    } catch (err) {
      const status = err.response?.status;
      if (status === 404) {
        setError("Evento non trovato.");
      } else if (status === 403) {
        setError("Non puoi avviare questo evento.");
      } else {
        setError(err.response?.data?.detail || "Impossibile verificare l'evento.");
      }
    } finally {
      setLookingUp(false);
    }
  };

  const handleStart = async () => {
    if (!eventToStart) return;
    setStarting(true);
    setError("");
    setSuccess("");
    try {
      await apiService.startEvent(eventToStart.id);
      setSuccess(`Evento "${eventToStart.name}" avviato. La diretta è visibile a tutti gli utenti in sala.`);
      setEventToStart(null);
      setEventId("");
    } catch (err) {
      const status = err.response?.status;
      const detail = err.response?.data?.detail;
      if (status === 404) {
        setError("Evento non trovato.");
      } else if (status === 403) {
        setError("Non puoi avviare questo evento.");
      } else if (status === 409) {
        setError(detail || "Questo evento non può essere avviato.");
      } else {
        setError(detail || "Avvio non riuscito.");
      }
      setEventToStart(null);
    } finally {
      setStarting(false);
    }
  };

  return (
    <div className="dashboard-card">
      <h1 className="dashboard-card__title">Inizia evento</h1>
      <p className="dashboard-card__subtitle">
        Inserisci l&apos;ID dell&apos;evento da avviare. La diretta partirà per tutti gli utenti che sono in sala in attesa.
      </p>

      {error && <FlashAlert variant="danger" onHidden={() => setError("")}>{error}</FlashAlert>}
      {success && <FlashAlert variant="success" onHidden={() => setSuccess("")}>{success}</FlashAlert>}

      <Form onSubmit={handleLookup} style={{ maxWidth: 420 }}>
        <Form.Group className="mb-3">
          <Form.Label htmlFor="start-event-id">ID evento</Form.Label>
          <Form.Control
            id="start-event-id"
            value={eventId}
            onChange={(e) => setEventId(e.target.value.replace(/\D/g, ""))}
            inputMode="numeric"
            placeholder="Es. 42"
            autoComplete="off"
          />
        </Form.Group>
        <Button type="submit" className="users-edit-btn" disabled={lookingUp || !eventId.trim()}>
          {lookingUp ? "Verifica..." : "Inizia evento"}
        </Button>
      </Form>

      <Modal show={Boolean(eventToStart)} onHide={closeConfirm} centered>
        <Modal.Header closeButton>
          <Modal.Title>Inizia evento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Vuoi avviare <strong>{eventToStart?.name}</strong> (ID {eventToStart?.id})? La diretta partirà per tutti gli utenti in sala.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeConfirm} disabled={starting}>Annulla</Button>
          <Button className="users-edit-btn" onClick={handleStart} disabled={starting}>
            {starting ? "Avvio..." : "Avvia"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DashboardStartEvents;
